<template>
	<InventarisationPageTemplate v-slot="{ selectedIndex, customers }">
		<DataRequestPage
			v-if="customers[selectedIndex]"
			:customer="customers[selectedIndex]"
		/>
	</InventarisationPageTemplate>
</template>

<script setup lang="ts">
import DataRequestPage from "./DataRequestPage.vue";
</script>
